import QSFRoute from './QSFRoute'

function QSFLayout() {
  return <QSFRoute />
}

export default QSFLayout
